var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronDownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_7126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.37013 6.73242C5.6631 6.72948 5.90333 6.62112 6.13771 6.3867L10.4678 1.95117C10.6465 1.77246 10.7344 1.56152 10.7344 1.30664C10.7344 0.785154 10.3155 0.363281 9.80275 0.363281C9.54787 0.363281 9.30763 0.46582 9.11719 0.662112L5.13575 4.77246H5.61329L1.62012 0.662112C1.42969 0.47168 1.19238 0.363281 0.931639 0.363281C0.416016 0.363281 0 0.785154 0 1.30664C0 1.5586 0.0908203 1.76953 0.263672 1.9541L4.59962 6.3867C4.83985 6.62694 5.07715 6.73242 5.37013 6.73242Z",
    fill: "current",
    fillOpacity: "{0.87}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_7126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.7344,
    height: 6.73242,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/ChevronDownIcon.53b56b4f2f6b5ff3ca63767ea1309ebe.svg";
export { ForwardRef as ReactComponent };